// import React from 'react';
// import { useDispatch } from 'react-redux';
// import { claimActions } from 'store';
// import { Images, useModal } from 'utils';
// import { CustomDelete } from './customDelete';
//
// const ACTION_TYPE = 'APPEAL_SUBMITTED_CLAIM';
// export const RemoveClaim = ({ claim, afterSuccess, noBtn }) => {
//     const dispatch = useDispatch();
//     const { open, close } = useModal();
//
//     return (
//         <div>
//             {noBtn ?
//                 <CustomDelete
//                     text={'This claim will no longer be marked as under appeal. The appeal reason will remain visible in claim history.'}
//                     info={'Remove Claim from Appeal'}
//                     innerText={'Remove'}
//                     handleDel={() => dispatch(claimActions.appealSubmittedClaim({
//                             id: claim?.id,
//                             mark: false,
//                             description: '',
//                         }, {}, claim?.id),
//                     )}
//                     afterSuccess={() => {
//                         close();
//                         afterSuccess && afterSuccess();
//                     }}
//                     actionType={ACTION_TYPE}
//                     body={
//                         <div>
//                             <div className="deleting-client-info-box"
//                                  style={{ alignItems: 'flex-start', marginBottom: 12 }}>
//                                 <img style={{ marginTop: '3px' }} src={Images.fileBlack} alt="icon" />
//                                 <p style={{ fontWeight: 600 }}>{claim?.displayId}</p>
//                             </div>
//                         </div>
//                     }
//                 />
//                 :
//                 <button
//                     className="remove-appeal-btn"
//                     onClick={() => open(
//                         <CustomDelete
//                             text={'This claim will no longer be marked as under appeal. The appeal reason will remain visible in claim history.'}
//                             info={'Remove Claim from Appeal'}
//                             innerText={'Remove'}
//                             handleDel={() => dispatch(claimActions.appealSubmittedClaim({
//                                     id: claim?.id,
//                                     mark: false,
//                                     description: '',
//                                 }, {}, claim?.id),
//                             )}
//                             afterSuccess={() => {
//                                 close();
//                                 afterSuccess && afterSuccess();
//                             }}
//                             actionType={ACTION_TYPE}
//                             body={
//                                 <div>
//                                     <div className="deleting-client-info-box"
//                                          style={{ alignItems: 'flex-start', marginBottom: 12 }}>
//                                         <img style={{ marginTop: '3px' }} src={Images.fileBlack} alt="icon" />
//                                         <p style={{ fontWeight: 600 }}>{claim?.displayId}</p>
//                                     </div>
//                                 </div>
//                             }
//                         />,
//                     )}>
//                     Remove Appeal
//                 </button>
//             }
//         </div>
//     );
// };

import React from 'react';
import { useDispatch } from 'react-redux';
import { claimActions } from 'store';
import { Images, useModal } from 'utils';
import { CustomDelete } from './customDelete';

const ACTION_TYPE = 'APPEAL_SUBMITTED_CLAIM';

export const RemoveClaim = ({ claim, afterSuccess, noBtn }) => {
    const dispatch = useDispatch();
    const { open, close } = useModal();

    const handleDelete = () => dispatch(claimActions.appealSubmittedClaim({ id: claim?.id, mark: false, description: '' }, {}, claim?.id));

    const handleAfterSuccess = () => {
        close();
        afterSuccess?.();
    };

    const deleteProps = {
        text: 'This claim will no longer be marked as under appeal. \u00A0 The appeal reason will remain visible in claim history.',
        info: 'Remove Claim from Appeal',
        innerText: 'Remove',
        handleDel: handleDelete,
        afterSuccess: handleAfterSuccess,
        actionType: ACTION_TYPE,
        body: (
            <div className="deleting-client-info-box" style={{ alignItems: 'flex-start', marginBottom: 12 }}>
                <img style={{ marginTop: 3 }} src={Images.fileBlack} alt="icon" />
                <p style={{ fontWeight: 600 }}>{claim?.displayId}</p>
            </div>
        ),
    };

    return noBtn ? (
        <CustomDelete {...deleteProps} />
    ) : (
        <button className="remove-appeal-btn" onClick={() => open(<CustomDelete {...deleteProps} />)}>
            Remove Appeal
        </button>
    );
};
